import { useNavigate } from 'react-router-dom';
import { Upload } from '../components/Upload';

export function Home() {
    const navigate = useNavigate();

    const handleUploadComplete = (bookId: string, fileUrl?: string) => {
        // Redirect to the reader with the new book ID
        // If it's a preview, pass the fileUrl in state
        if (bookId === 'preview' && fileUrl) {
            navigate(`/reader/preview`, { state: { fileUrl } });
        } else {
            navigate(`/reader/${bookId}`);
        }
    };

    return (
        <div className="h-full flex flex-col items-center justify-center">
            <Upload onUploadComplete={handleUploadComplete} />
        </div>
    );
}
